import { useEffect, useState } from "react";
import { generateOnlineBillLink } from "../../api/api";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import { ManualPaymentForm } from "../../utility/validationRules";
import { FormProps } from '../../utility/types';
import Spinner from "../../components/_common/Spinner";
import { Col, Modal, Row } from "antd";
import FormContainer from "../../components/FormContainer/FormContainer";
import { BankGateWayLogo, InfoText, PaymentGatewayContainer } from "./styles";
import { CreditCardFilled, DollarCircleFilled, InfoCircleFilled } from '@ant-design/icons';

export const TemperatureOnlinePaymentdialog: React.FC<FormProps> = ({ visible, onSubmit, onCancel, payLoad, setShowDialog }) => {

    const { values, errors, handleChange, handleSubmit, setErrors, setValues } = useForm(ManualPaymentForm) as any
    const [FormState, SetFormState] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [isSavingData, setIsSavingData] = useState(true);

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type];
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect(() => {
        if (payLoad.bill !== null && payLoad.onlinePaymentGateway !== null) setIsLoading(false);
        console.log(payLoad.onlinePaymentGateway);
    }, [payLoad])

    const onGatewayClick = (x: any) => {

        setIsSubmiting(true)

        generateOnlineBillLink(
            payLoad.requestid,
            payLoad.bill.prk_AndriodLab_AutoID,
            x.str_GUID,
            0
        )
            .then((result: any) => {
                sucessNotify("در حال انتقال به درگاه پرداخت آنلاین", undefined, 5000)
                setIsSubmiting(false)
                window.location.replace(result.data.data);
                console.log(result)
            })
            .catch((error) => {
                console.log(error);
                setIsSubmiting(false)
                errorNotify(error.response.data.errorMessage, undefined, 5000)
            })


    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                {isLoading === true && (
                    <Spinner />
                )}
                {isLoading === false && (

                    <FormContainer title="پرداخت آنلاین" saveButtonTitle={""} onSubmit={undefined} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >

                        {payLoad.bill !== undefined && (
                            <Row>
                                <Col>
                                    <InfoCircleFilled style={{ color: 'red', fontSize: '16px' }} />
                                </Col>

                                <Col lg={23} md={23} sm={23} xs={23}>
                                    <InfoText>شماره فاکتور: {payLoad.bill.prk_ParsicLabBill_AutoID ? payLoad.bill.prk_ParsicLabBill_AutoID : 0}</InfoText>
                                </Col>

                            </Row>
                        )}

                        {payLoad.bill !== undefined && (
                            <Row>
                                <Col>
                                    <DollarCircleFilled style={{ color: 'orange', fontSize: '16px' }} />
                                </Col>

                                <Col lg={23} md={23} sm={23} xs={23}>
                                    <InfoText>مبلغ: {payLoad.bill.int_BillAmount ? payLoad.bill.int_BillAmount.toLocaleString() : 0}</InfoText>
                                </Col>

                            </Row>
                        )}

                        <Row>
                            <Col>
                                <CreditCardFilled style={{ color: 'green', fontSize: '16px' }} />
                            </Col>

                            <Col lg={23} md={23} sm={23} xs={23}>
                                <InfoText>{"برای پرداخت ، بعد از انتخاب مبلغ مورد نظر ، بر روی آیکن یکی از درگاه های بانکی زیر کلیک نمایید"}</InfoText>
                            </Col>

                        </Row>

                        <PaymentGatewayContainer >
                            <Row>
                                {payLoad.onlinePaymentGateway !== undefined && (
                                    payLoad.onlinePaymentGateway.map((x: any) => {
                                        return (
                                            <Col >
                                                <BankGateWayLogo title={x.str_PSPName} alt={x.str_PSPName} onClick={() => onGatewayClick(x)} src={'data:image/jpeg;base64,' + x.str_Logo}></BankGateWayLogo>
                                            </Col>
                                        )
                                    })
                                )}
                            </Row>
                        </PaymentGatewayContainer>


                    </FormContainer>

                )}
            </>

        </Modal>
    )
}